// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"404929cf","225":"4a4187aa"}[chunkId] + ".chunk.css";
};